/*
================================================================
	Copyright © 2024, Cheers Interactive Pvt Ltd.  All rights reserved.
	  File Description : Deliverable Planning Routes 
----------------------------------------------------------------
	Creation Details
	Date Created				: 03/Mar/2025
	Author						: Satya Prakash Mall
================================================================
*/
import React, { Suspense } from "react";
import { Switch } from "react-router-dom";
import AuthLayout from "../app/layout/authLayout";
import DeliverablePlanningListing from "../app/views/deliverablePlanning";

const PROPERTIES = ["Properties:VIEW", "Properties:FULL"];

const deliverablePlanningRoutes = () => (
  <Suspense
    fallback={
      <div className="text-center">
        <h3>Loading...</h3>
      </div>
    }
  >
    <Switch>
      <AuthLayout
        exact
        path="/custom-projects"
        component={DeliverablePlanningListing}
        pageHeading="GenNx CMS - Deliverable Planning"
        accessRights={{
          moduleName: "Deliverable Planning",
          parentModuleName: "",
          moduleAttribute: [...PROPERTIES],
          interfaceName: "Listing",
        }}
      />
    </Switch>
  </Suspense>
);

export default deliverablePlanningRoutes;
